module.exports = __webpack_public_path__ + "static/media/19ESCAP43.f5f4cd7e.jpg";